import ShowByRoles from './show-by-role.directive';

export default {
  ShowByRoles,
};
